export function utcOffsetLabel(tz: string) {
  try {
    const name = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      timeZoneName: 'shortOffset',
    })
      .formatToParts(new Date())
      .find((p) => p.type === 'timeZoneName')?.value;
    return (name ?? '').replace('GMT', 'UTC');
  } catch {
    return '';
  }
}
